import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import '../styles/pagination.css'

const LEFT_PAGE = 'LEFT'
const RIGHT_PAGE = 'RIGHT'

/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 */
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
}

class Pagination extends Component {
  // constructor(props) {
  //   super(props)
    
  //   // const { totalRecords = null, pageLimit = 30, pageNeighbours = 0 } = props
    
  //   // this.pageLimit = typeof pageLimit === 'number' ? pageLimit : 30
  //   // this.totalRecords = typeof totalRecords === 'number' ? totalRecords : 0

  //   // // pageNeighbours only can be: 0, 1 or 2
  //   // this.pageNeighbours = typeof pageNeighbours === 'number' 
  //   //   ? Math.max(0, Math.min(pageNeighbours, 2))
  //   //   : 0

  //   // // this.totalPages = Math.cell(this.totalRecords / this.pageLimit)
  //   // this.totalPages = this.props.totalPages

  //   // this.state = {
  //   //   currentPage: 1
  //   // }
  // }

  // componentDidMount() {
  //   this.gotoPage(1)
  // }

  gotoPage = page => {
    const { onPageChanged = f => f } = this.props

    // const currentPage = Math.max(0, Math.min(page, this.totalPages))
    const currentPage = Math.max(0, Math.min(page, this.props.totalPages))

    const paginationData = {
      currentPage,
      // totalPages: this.totalPages,
      // pageLimit: this.pageLimit,
      // totalRecords: this.totalRecords,
    }

    // this.setState({ currentPage }, () => onPageChanged(paginationData))
    onPageChanged(paginationData)
  }

  handleClick = page => evt => {
    evt.preventDefault();
    this.gotoPage(page);
  }

  handleMoveLeft = evt => {
    evt.preventDefault();
    // this.gotoPage(this.state.currentPage - (this.pageNeighbours * 2) - 1);
    this.gotoPage(this.props.currentPage - (this.props.pageNeighbours * 2) - 1);
  }

  handleMoveRight = evt => {
    evt.preventDefault();
    // this.gotoPage(this.state.currentPage + (this.pageNeighbours * 2) + 1);
    this.gotoPage(this.props.currentPage + (this.props.pageNeighbours * 2) + 1);
  }

  /**
   * Let's say we have 10 pages and we set pageNeighbours to 2
   * Given that the current page is 6
   * The pagination control will look like the following:
   *
   * (1) < {4 5} [6] {7 8} > (10)
   *
   * (x) => terminal pages: first and last page(always visible)
   * [x] => represents current page
   * {...x} => represents page neighbours
   */
  fetchPageNumbers = () => {
    // const totalPages = this.totalPages
    // const currentPage = this.state.currentPage
    // const pageNeighbours = this.pageNeighbours
    const totalPages = this.props.totalPages
    const currentPage = this.props.currentPage
    const pageNeighbours = this.props.pageNeighbours

    /**
     * totalNumbers: the total page numbers to show on the control
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
     */
    const totalNumbers = (pageNeighbours * 2) + 3
    const totalBlocks = totalNumbers + 2

    if (totalPages > totalBlocks) {
      const startPage = Math.max(2, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      // console.log(`startPage: ${startPage}, endPage: ${endPage}`)

      let pages = range(startPage, endPage);
      // console.log(`pages: ${pages}`)
      
      /**
       * hasLeftSpill: has hidden pages to the left
       * hasRightSpill: has hidden pages to the right
       * spillOffset: number of hidden pages either to the left or to the right
       */
      const hasLeftSpill = startPage > 2;
      const hasRightSpill = (totalPages - endPage) > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        // handle: (1) < {5 6} [7] {8 9} (10)
        case (hasLeftSpill && !hasRightSpill): {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }

        // handle: (1) {2 3} [4] {5 6} > (10)
        case (!hasLeftSpill && hasRightSpill): {
          const extraPages = range(endPage + 1, endPage + spillOffset);
          pages = [...pages, ...extraPages, RIGHT_PAGE];
          break;
        }

        // handle: (1) < {4 5} [6] {7 8} > (10)
        case (hasLeftSpill && hasRightSpill):
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }

      return [1, ...pages, totalPages];
    }

    return range(1, totalPages);
  }

  render() {
    // console.log(`totalRecords: ${this.totalRecords}, totalPages: ${this.totalPages}`)
    // if (!this.totalRecords || this.totalPages === 1) return null

    const { totalRecords, totalPages, currentPage } = this.props
    if (!totalRecords || !totalPages || totalPages === 1) return null

    const pages = this.fetchPageNumbers()

    return (
      <Fragment>
        <nav className="nav-pagination" aria-label="Countries Pagination">
          <ul className="pagination-list">
            {
              pages.map( (page, index) => {
                if (page === LEFT_PAGE) return (
                  <li key={index} className="page-item">
                    <Link to='#' className='page-link' aria-label='Previous' onClick={this.handleMoveLeft}>
                      <span aria-hidden="true">&laquo;</span>
                      <span className="sr-only">Previous</span>
                    </Link>
                  </li>
                )

                if (page === RIGHT_PAGE) return (
                  <li key={index} className="page-item">
                    <Link className="page-link" to="#" aria-label="Next" onClick={this.handleMoveRight}>
                      <span aria-hidden="true">&raquo;</span>
                      <span className="sr-only">Next</span>
                    </Link>
                  </li>
                );
  
                return (
                  <li key={index} className={`page-item${ currentPage === page ? ' active' : ''}`}>
                    <Link className="page-link" to="#" onClick={ this.handleClick(page) }>{ page }</Link>
                  </li>
                );

              })
            }
          </ul>
        </nav>
      </Fragment>
    )
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number,
  totalRecords: PropTypes.number,             // the total number of records to be paginated
  pageLimit: PropTypes.number,                // the number of records to be shown per page
  pageNeighbours: PropTypes.number,           // the number of additional page numbers to show on each side of the current page
  onPageChanged: PropTypes.func
}

export default Pagination